import {
  AccessContext,
  DynamicColumn,
  EnumField,
  ForeignKeyField,
  Required,
  Schema,
  TextField
} from "lego-gui-lib/lib";
import { api, mainStore } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { QueueConfigurationFKNotRequired } from "../queueConfig/schema";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import {
  queryParamDtoStrategy,
  queryParamParentChangeStrategy
} from "lego-gui-lib/lib/dataAccess/ChildDataSourceStrategies";
import { Auth } from "../../core/model/auth";
import { serviceProfileAllows } from "../serviceProfile/validator";
import { FormState } from "final-form";
import { BooleanField } from "../../common/common";

export enum HuntingGroupType {
  Sequential = 0,
  Cyclic = 1,
  Parallel = 2
}

export const TypeTypes = [
  {
    label: t("hns:huntingGroup:type.Sequential"),
    value: HuntingGroupType.Sequential
  },
  { label: t("hns:huntingGroup:type.Cyclic"), value: HuntingGroupType.Cyclic },
  {
    label: t("hns:huntingGroup:type.Parallel"),
    value: HuntingGroupType.Parallel
  }
];

const onQueueActiveChange = (
  newValue: any,
  oldValue: any,
  formState: FormState<any>
) => {
  if (newValue == 0) {
    formState.values["queueConfigRef"] = null;
  }
};

export const HuntingGroupSchema = new Schema<DynamicColumn>({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  },
  fields: [
    {
      name: "name",
      title: t("common:name"),
      type: TextField(Required)
    },
    {
      name: "huntingType",
      title: t("common:type"),
      type: EnumField(TypeTypes, Required)
    },
    {
      name: "queueActive",
      title: t("hns:huntingGroup:queueActive"),
      type: BooleanField(Required),
      onChange: onQueueActiveChange
    },
    {
      name: "queueConfigRef",
      title: t("hns:queueConfig:domain"),
      type: QueueConfigurationFKNotRequired
    }
  ]
});

export const HuntingGroupSchemaForm = (san: any) =>
  HuntingGroupSchema.extend({
    queueConfigRef: {
      if: (ctx: AccessContext) =>
        ctx.data?.queueActive === 1 &&
        serviceProfileAllows({ data: san.oneDataSource.one }, "featQueue")
    },
    queueActive: {
      if: () =>
        serviceProfileAllows({ data: san.oneDataSource.one }, "featQueue")
    }
  });

export const HuntingGroupSchemaColumns = (san: any) =>
  HuntingGroupSchema.extend({
    queueConfigRef: {
      if: () =>
        serviceProfileAllows({ data: san.oneDataSource.one }, "featQueue")
    },
    queueActive: {
      if: () =>
        serviceProfileAllows({ data: san.oneDataSource.one }, "featQueue")
    }
  });

mainStore.huntingGroup = RemoteChildDataSource.create({
  parent: mainStore.SAN.oneDataSource,
  parentChangedStrategy: queryParamParentChangeStrategy("id", "sanRef"),
  dtoStrategy: queryParamDtoStrategy("id", "sanRef"),
  api: api,
  name: "huntingGroup",
  schema: HuntingGroupSchema,
  url: "/huntingGroups",
  commons: mainStore.commons
});

mainStore.huntingGroupFk = RemoteChildDataSource.clone(mainStore.huntingGroup);

export const HuntingGroupFK = ForeignKeyField({
  dataSource: mainStore.huntingGroupFk.listDataSource,
  labelField: "name",
  valueField: "id",
  minWidth: 70
});

export const HuntingGroupRequiredFK = ForeignKeyField(
  {
    dataSource: mainStore.huntingGroupFk.listDataSource,
    labelField: "name",
    valueField: "id",
    minWidth: 70
  },
  Required
);
